import { memo } from "react";
import PropTypes from "prop-types";
import Spinner from "react-bootstrap/Spinner";

const Spinners = ({ className, message }) => {
  return (
    <div className={className || "spin_overlay"}>
      <Spinner animation="border" variant="primary" />
      {message && <div className="spin_message">{message}</div>}
    </div>
  );
};

Spinners.propTypes = {
  className: PropTypes.string,
};

Spinners.defaultProps = {
  className: "spin_overlay",
};

export default memo(Spinners);
